import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4 py-6 bg-grey lighten-4 d-flex align-center"},[_c(VAutocomplete,{attrs:{"items":_vm.centers,"item-text":"desc","item-value":"_id","label":"Centri sportivi gestiti","return-object":"","loading":_vm.loading,"hide-no-data":"","dense":"","hide-details":""},on:{"change":_vm.handleSwitch},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }